import { useTranslation } from "react-i18next";

import { EmptyList } from "@/modules/theme/components/EmptyList/EmptyList";
import { Typography } from "@/modules/theme/components/Typography/Typography";

import { HandbookItem } from "./HandbookItem/HandbookItem";

export type SerializedHandbook = {
  id: string;
  name: string;
};

type HandbooksListProps = {
  handbooks: SerializedHandbook[] | undefined;
};

const translationNamespace = "pages/HandbooksPage";

export const HandbooksList = ({ handbooks = [] }: HandbooksListProps) => {
  const { t } = useTranslation(translationNamespace);

  if (!handbooks.length) {
    return (
      <EmptyList>
        <Typography variant="contentMedium">
          {t("There are no handbooks matching your search criteria")}
        </Typography>
      </EmptyList>
    );
  }

  return (
    <ul>
      {handbooks &&
        handbooks.map((handbook) => (
          <HandbookItem
            handbookId={handbook.id}
            handbookName={handbook.name}
            key={handbook.id}
          />
        ))}
    </ul>
  );
};
